import styled from 'styled-components';

interface IListItemProps {
  borderTop?: boolean;
  isFirst?: boolean;
  isLast?: boolean;
}

export const ListItem = styled.div<IListItemProps>`
  display: flex;
  flex-direction: column;
  border-top: ${props => props.borderTop ? '1px solid #ddd' : 'none'};
  padding-top: ${props => props.isFirst ? '0px' : '5px'};
  padding-bottom: ${props => props.isLast ? '0px' : '5px'};
`;

export const NfBlock = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
    align-items: flex-start;
`;

export const LeftContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const RightContainer = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: flex-end;
`;

export const Title = styled.div`
    display: flex;
    font-weight: bold;
`;

export const Details = styled.div`
    display: flex;
    font-size: 0.9em;
`;

export const CreatedAt = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const Status = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const FooterContent = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const HistoryBlock = styled.div`
  margin: 0 10px 0 10px;
  padding: 5px 0px;
  border-top: 1px dashed #dfdfdf;
  font-size: 0.85em;
  text-align: justify;
`;
